import { useCallback, useState } from "react";
import { eliminarProducto } from "../../../services/backend/cotizacionService";
import logger from "../../../shared/utils/logger";

const useCartPreview = ({ updateCartQuantityFromBackend, loadCotizacionFromBackend, selectedAlmacen, toastRef }) => {
  const [previewStatus, setPreviewStatus] = useState("idle");

  const handlePreviewRemoveItem = useCallback(async (item) => {
    const backendDetailId = item?.backendDetailId || null;
    if (!backendDetailId) {
      toastRef.current?.show({
        severity: "error",
        summary: "No se puede eliminar",
        detail: "No se puede eliminar este producto (sin detalle backend).",
        life: 3200,
      });
      return;
    }
    setPreviewStatus("loading");
    try {
      await eliminarProducto(backendDetailId);
      await loadCotizacionFromBackend(selectedAlmacen);
      setPreviewStatus("success");
      toastRef.current?.show({
        severity: "success",
        summary: "Producto eliminado",
        detail: `${item.name} se eliminó del carro.`,
        life: 2200,
      });
    } catch (error) {
      logger.error("No fue posible eliminar el producto.", error);
      setPreviewStatus("error");
      toastRef.current?.show({
        severity: "error",
        summary: "No se pudo eliminar",
        detail: error?.message || "Error al eliminar producto del carro.",
        life: 3200,
      });
    } finally {
      setTimeout(() => setPreviewStatus("idle"), 600);
    }
  }, [loadCotizacionFromBackend, selectedAlmacen, toastRef]);

  const handlePreviewQuantityChange = useCallback(async (item, delta) => {
    const newQty = Number(item.quantity || 0) + delta;
    if (newQty < 1) {
      handlePreviewRemoveItem(item);
      return;
    }
    setPreviewStatus("loading");
    try {
      await updateCartQuantityFromBackend(item.code, newQty);
      setPreviewStatus("success");
      toastRef.current?.show({
        severity: "success",
        summary: "Cantidad actualizada",
        detail: `${item.name}: ${newQty} unidad${newQty === 1 ? "" : "es"}.`,
        life: 1800,
      });
    } catch (error) {
      logger.error("No fue posible actualizar la cantidad.", error);
      setPreviewStatus("error");
      toastRef.current?.show({
        severity: "error",
        summary: "No se pudo actualizar",
        detail: error?.message || "Error al actualizar la cantidad.",
        life: 3200,
      });
    } finally {
      setTimeout(() => setPreviewStatus("idle"), 600);
    }
  }, [handlePreviewRemoveItem, updateCartQuantityFromBackend, toastRef]);

  return {
    previewStatus,
    handlePreviewRemoveItem,
    handlePreviewQuantityChange,
  };
};

export default useCartPreview;
